export enum LoginStatus {
	None,
	NormalUser,
	CommunityMissing,
	ProfileMissing,
	ProfileNotActivated,
	RedirectToCommunity,
	CommunityWaiting
}